import React from 'react'
import { connect } from 'react-redux';

import history from '../../../history';
import { publishLog } from '../../utils/Logs';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
  
    async componentDidCatch(error, errorInfo) {
        let token = localStorage.getItem("token")
        console.error("error boundary", error, errorInfo);

        const { model } = this.props

        if(import.meta.env.MODE === "production"){
            await publishLog(token, {
                message: error.toString(),
                url: window.location.href,
                stack: errorInfo.componentStack,
                siteAccessed: model?.sites?.length > 0 && 
                model?.siteActiveIdx && model?.sites[model?.siteActiveIdx] ?
                model?.sites[model?.siteActiveIdx] : {},
                type: "ERROR"
            })
        }
    }
  
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <div class="container" id="errorContainer">
                <div class="row justify-content-center align-items-center">                    
                    <div class="col" style={{textAlign:"center"}}>
                        <span className="pull-right fa-3x" aria-hidden="true" onClick={() => {
                            this.setState({
                                ...this.state,
                                hasError: false
                            })
                            history.push('/overview')
                        }}>&times;</span>
                        <h1>An Error has occurred</h1>
                        <h5>We have been alerted and are currently looking into it</h5>
                    </div>
                </div>
            </div>
        } else {            
            return this.props.children; 
        }
    }
}


const mapStateToProps = (state) => ({
    model: state.site.model
})

export default connect(mapStateToProps, null)(ErrorBoundary)